module.exports = __webpack_public_path__ + "fonts/MyriadPro-BoldCondIt.1f1e4f8.woff";